import * as m from 'mithril';


export type CustomSvgIconType = "back_arrow" | "more_vert" | "arrow_forward" | "keyboard_arrow_up" | "keyboard_arrow_down" | "keyboard_arrow_left" | "keyboard_arrow_right" |
    "calendar" | "bi_calendar" | "fa_calendar" | "menu" | "search" |
    "edit" | "expand_more" | "expand_less" | "language" |
    "add_box" | "close" | "restore" | "add" | "remove" | "image" | "photo_size_select_actual" | "radio_button_unchecked" |
    "radio_button_checked" | "location_city" | "location_arrow" | "arrival" | "operator_photo" | "sun" | "moon" | "filter" | "route" | "grid" | "source_location" |
    "destination_location" | "arrow_right" | "clock" | "clock_history" | "dot" | "xmark" |
    "warning_sign" | "success_sign" | "success_sign_outline" | "phone" | "circle_dot" | "exclamation_circle" | "exclamation_triangle" | "check_circle" |
    "sun" | "moon" | "plus" | "minus" | "long_arrow_alt_right" | "double_chevron_right" | "angle_right"
    | "caret_arrow_up" | "caret_arrow_down" | "caret_arrow_left" | "caret_arrow_right" | "cross_remove" | "cross_remove_fill" |
    "calendar" | "image" | "tag_fill" | "bus" | "car" | "arrow_rotate_right" | "arrow_wide_short_down";

/*    
const cssIconClasses = {
    back_arrow: "svg-back-arrow",
    more_vert: "svg-more-vert",
    arrow_forward: "svg-arrow-forward",
    keyboard_arrow_up: "svg-keyboard-arrow-up",
    keyboard_arrow_down: "svg-keyboard-arrow-down",
    keyboard_arrow_left: "svg-keyboard-arrow-left",
    keyboard_arrow_right: "svg-keyboard-arrow-right",
    calendar: "svg-calendar",
    bi_calendar: "svg-bi-calendar",
    fa_calendar: "svg-fa-calendar",
    menu: "svg-menu",
    search: "svg-search",
    edit: "svg-edit",
    expand_more: "svg-expand-more",
    expand_less: "svg-expand-less",
    language: "svg-language",
    add_box: "svg-add-box",
    close: "svg-close",
    restore: "svg-restore",
    add: "svg-add",
    remove: "svg-remove",
    image: "svg-image",
    photo_size_select_actual: "svg-photo-size-select-actual",
    radio_button_unchecked: "svg-radio-button-unchecked",
    radio_button_checked: "svg-radio-button-checked",
    location_city: "svg-location-city",
    location_arrow: "svg-location-arrow",
    arrival: "svg-arrival",
    operator_photo: "svg-operator-photo",
    sun: "svg-sun",
    moon: "svg-moon",
    filter: "svg-filter",
    route: "svg-route",
    grid: "svg-grid",
    source_location: "svg-source-location",
    destination_location: "svg-destination-location",
    arrow_right: "svg-arrow-right",
    clock: "svg-clock",
    clock_history: "svg-clock-history",
    dot: "svg-dot",
    xmark: "svg-xmark",
    warning_sign: "svg-warning-sign",
    success_sign: "svg-success-sign",
    success_sign_outline: "svg-success-sign-outline",
    phone: "svg-phone",
    circle_dot: "svg-circle-dot",
    exclamation_circle: "svg-exclamation-circle",
    exclamation_triangle: "svg-exclamation-triangle",
    check_circle: "svg-check-circle",
    plus: "svg-plus",
    minus: "svg-minus",
    long_arrow_alt_right: "svg-long-arrow-alt-right",
    double_chevron_right: "svg-double-chevron-right",
    angle_right: "svg-angle-right",
    caret_arrow_up: "svg-caret-arrow-up",
    caret_arrow_down: "svg-caret-arrow-down",
    caret_arrow_left: "svg-caret-arrow-left",
    caret_arrow_right: "svg-caret-arrow-right",
    cross_remove: "svg-cross-remove",
    cross_remove_fill: "svg-cross-remove-fill",
    tag_fill: "svg-tag-fill",
    bus: "bus"
};
*/

let spriteUrl: string|undefined;


let CustomSvgIcon: m.Component<{
    iconType: CustomSvgIconType,
    themeCssClass: string,
}> = {
    oninit: () => {
        if(spriteUrl == undefined){
            console.debug("SpriteUrl is undefined. so reading from body dataset")
            spriteUrl = document.body.dataset.spriteSvgUrl || "/assets/sprite.svg";
        }
    },
    view: function ({ attrs }) {
        //const cssIconClass = cssIconClasses[attrs.iconType];

        //with separate svg and css(icon.css file)
        /* return m("span.icon", {
                class: cssIconClass + " " + attrs.themeCssClass,
                "aria-hidden": "true"
            }); */


        //with svg sprite, must remove icon.css file
        return m("svg", {
            class: attrs.themeCssClass,
            //fill: attrs.color? attrs.color: "currentcolor"
        },
            /*  m("use", { "xlink:href": "./sprite.svg#" + attrs.iconType }) */
            m("use", { "xlink:href": `${spriteUrl}#${attrs.iconType}` })
        )

    }
}

export default CustomSvgIcon;